import Grid from '@mui/material/Grid';
import { Paper, Stack } from '@mui/material';
import { DateRangePicker, DateRange, LocalizationProvider } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

import 'dayjs/locale/de';
import PageHeader from '../../common/Components/PageHeader';
import UserFeedbackListGrid from './UserFeedbackListGrid';
import UserFeedbackCharts from './UserFeedbackCharts';
import { useFetch } from '../../hooks/useFetch';
import { UserFeedback as UserFeedbackModel } from '@aviation/cabinapp-userfeedbackservice-sdk';


function UserFeedback() {
    const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([dayjs().subtract(7, 'day'), dayjs()]);
    const { status, data = [] } = useFetch<Array<UserFeedbackModel>>(`/api/userfeedback/bydate/${dateRange[0]?.format('YYYY-MM-DD')}/to/${dateRange[1]?.format('YYYY-MM-DD')}`);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <PageHeader title='User Feedback'>
                    <Stack direction='row' spacing={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
                            <DateRangePicker value={dateRange} format='DD.MM.YYYY' onChange={setDateRange} slotProps={{ textField: { size: 'small' } }} />
                        </LocalizationProvider>
                    </Stack>
                </PageHeader>
            </Grid>
            <Grid item xs={12} md={8}>
                <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: '100px' }} elevation={3}>
                    <UserFeedbackListGrid data={data} status={status} />
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <UserFeedbackCharts data={data} />
            </Grid>
        </Grid>
    );
}

export default UserFeedback;
